import React, {useEffect, useImperativeHandle, useRef} from 'react';
import {isEmptyObject, testCpf} from '../../../../helpers';
import {Input} from '../../../../components/atoms';
import {useLocation} from 'react-router-dom';
import {strings} from '../../../../assets';
import {Mask} from '@tboerc/maskfy';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

const CALLER = 'DADOS';

const INITIAL_VALUES = {
  cpf: '',
  pep: false,
  cep: '',
  rua: '',
  cidade: '',
  bairro: '',
  uf: '',
  numero: '',
  complemento: '',
};

const Dados = ({position, current, checkAdvance, corPrimaria}) => {
  const location = useLocation();
  const corretor = location.search;
  const isCostumer = !!corretor;
  const sizeRef = useRef();

  useImperativeHandle(ref, () => ({
    ref: sizeRef,
    values: () => ({caller: CALLER, data: values}),
  }));

  const cpf = useRef();
  const cep = useRef();
  const street = useRef();
  const district = useRef();
  const city = useRef();
  const uf = useRef();
  const number = useRef();
  const complement = useRef();

  const {handleChange, handleBlur, setValues, setFieldValue, errors, touched, values} = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema,
    initialErrors: strings.INITIAL_ERRORS,
  });

  const busca_cep = async () => {
    if (values.cep.length === 9) {
      const {data: resp} = await axios.get(`https://viacep.com.br/ws/${values.cep}/json/`);
      setValues({...values, rua: resp.logradouro, bairro: resp.bairro, cidade: resp.localidade, uf: resp.uf});
    }
  };

  useEffect(() => {
    if (current === position) checkAdvance({caller: CALLER, status: isEmptyObject(errors)});
  });

  return (
    <form className="formStep" ref={sizeRef}>
      <div className="controlForms">
        <div className="leftSide">
          <h1 style={{color: !!corPrimaria ? corPrimaria : '#023a86'}}>Dados</h1>
          {isCostumer ? (
            <p className="mt-4">Insira seu CPF e endereço para finalizarmos o processo de cotação do seu seguro.</p>
          ) : (
            <p className="mt-4">Adicione outros dados do usuário para finalizar o cadastro.</p>
          )}
        </div>
        <div className="rightSide">
          <div className="formGroup">
            <div className="group">
              <label>CPF</label>
              <Input
                ref={cpf}
                nextTabRef={cep}
                placeholder="000.000.000-00"
                name="cpf"
                type="tel"
                inputMode="numeric"
                value={values.cpf}
                onChangeText={handleChange('cpf')}
                onBlur={handleBlur('cpf')}
                formatText={Mask.cpf.value}
              />
              {errors?.cpf && <small className={'text-danger errorInput'}>{errors?.cpf}</small>}
            </div>

            <div className="group">
              <label>Endereço</label>
              <Input
                ref={cep}
                nextTabRef={number}
                placeholder="00000-000"
                type="tel"
                name="cep"
                inputMode="numeric"
                value={values.cep}
                onChangeText={handleChange('cep')}
                onBlur={busca_cep}
                formatText={Mask.cep.value}
                especialErro={touched.cep && errors.cep && 'addressError'}
              />
            </div>

            <div className="group">
              <Input
                ref={street}
                nextTabRef={district}
                placeholder="Rua"
                name="rua"
                value={values.rua}
                onChangeText={handleChange('rua')}
                onBlur={handleBlur('rua')}
                especialErro={touched.rua && errors.rua && 'addressError'}
              />
            </div>

            <div className="group">
              <Input
                ref={district}
                nextTabRef={city}
                placeholder="Bairro"
                name="bairro"
                value={values.bairro}
                onChangeText={handleChange('bairro')}
                onBlur={handleBlur('bairro')}
                especialErro={touched.bairro && errors.bairro && 'addressError'}
              />
            </div>

            <div className="rowGroup">
              <div className="group spSize">
                <Input
                  ref={city}
                  nextTabRef={uf}
                  placeholder="Cidade"
                  name="cidade"
                  value={values.cidade}
                  onChangeText={handleChange('cidade')}
                  onBlur={handleBlur('cidade')}
                  especialErro={touched.cidade && errors.cidade && 'addressError'}
                />
              </div>

              <div className="group mnSize">
                <Input
                  ref={uf}
                  nextTabRef={number}
                  placeholder="UF"
                  name="uf"
                  inputMode="numeric"
                  value={values.uf}
                  onChangeText={handleChange('uf')}
                  onBlur={handleBlur('uf')}
                  especialErro={touched.uf && errors.uf && 'addressError'}
                />
              </div>
            </div>

            <div className="rowGroup">
              <div className="group mnSize">
                <Input
                  ref={number}
                  nextTabRef={complement}
                  type="number"
                  placeholder="Numero"
                  name="numero"
                  value={values.numero}
                  onChangeText={handleChange('numero')}
                  onBlur={handleBlur('numero')}
                  especialErro={touched.numero && errors.numero && 'addressError'}
                />
              </div>

              <div className="group spSize">
                <Input
                  ref={complement}
                  nextTabRef={street}
                  placeholder="Complemento"
                  name="complemento"
                  value={values.complemento}
                  onChangeText={handleChange('complemento')}
                  onBlur={handleBlur('complemento')}
                />
              </div>
            </div>

            <div className="radioGroup">
              <div className="radioHeader">
                <p>Pessoa politicamente exposta?</p>
              </div>
              <div className="radioFields">
                <input
                  tabIndex={-1}
                  type="radio"
                  value={true}
                  checked={values.pep === true ? true : false}
                  name="pep"
                  id="yes"
                  onClick={() => setFieldValue('pep', true)}
                  onChange={() => {}}
                />
                <label htmlFor="yes">Sim</label>
                <input
                  tabIndex={-1}
                  type="radio"
                  value={false}
                  checked={values.pep === true ? false : true}
                  name="pep"
                  id="not"
                  onClick={() => setFieldValue('pep', false)}
                  onChange={() => {}}
                />
                <label htmlFor="not">Não</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

const validationSchema = Yup.object().shape({
  cpf: Yup.string().test('vcpf', strings.invalid_cpf, testCpf).required(strings.required),
  pep: Yup.boolean().required(strings.required),
  cep: Yup.string().max(9, 'Máximo de 9 caracteres').required(strings.required),
  rua: Yup.string().max(70, 'Máximo de 70 caracteres').required(strings.required),
  numero: Yup.number('Somente números com até 5 caracteres.')
    .required('Somente números com até 5 caracteres.')
    .test('regex', 'Somente números com até 5 caracteres.', (val) => {
      let regExp = new RegExp(/^\d{1,5}$/);

      return regExp.test(val);
    }),
  cidade: Yup.string().max(75, 'Máximo de 75 caracteres').required(strings.required),
  bairro: Yup.string().max(75, 'Máximo de 75 caracteres').required(strings.required),
  uf: Yup.string().max(2, 'Máximo de 2 caracteres').required(strings.required),
  complemento: Yup.string().max(15, 'Máximo de 15 caracteres'),
});

export default React.memo(Dados);
export const ref = React.createRef();
